export const SupportEmail = "mailto:help@jokerplus.com";

export const TermsConditionLink = "/terms_conditions";

export const PrivacyPolicyLink = "/privacy";

export const ApkLink = "https://main.jokerplus.com/apk/jokerplusv3.apk";

export const MOBILE_MAX_WIDTH_PX = 768;
